<template>
    <div class="step-stepper">

        <div class="step-stepper--header">
            <span class="roboto black--text f15 step-stepper--title" :style="value > 0 ? 'font-weight: 600;' : ''" v-html="title" />
            <slot v-if="showPrice" name="price">
                <div class="step-stepper--price roboto f14" style="margin-top: -2px; color: #7B8088;" :style="value > 0 ? 'color: #000;' : 'color: #999'">
                    <slot name="unit-price">
                        {{ value }} &times; <pm-price :value="unitPrice" hide-currency /> = <pm-price :value="value * unitPrice" :currency="$store.state.currency" />
                    </slot>
                </div>
            </slot>
        </div>
        <div class="step-stepper--buttons">
            <div :style="value > 0 ? 'border: 1px solid #aaa;' : 'border: 1px solid #ddd; color: #aaa;'" class="elevation-0 step-stepper--button step-stepper--button-decrease"
                 @touchstart="onTouchStart"
                 @touchmove="onTouchMove"
                 @touchend="onTouchEnd(0 - step)" style="line-height: 29px; background: #fff!important;">-</div>
            <span class="step-stepper--counter roboto f15" :class="value > 0 ? 'black--text bold--text' : 'grey--text text--darken-3'">
                <slot name="amount">{{ value }}</slot>
            </span>
            <div :style="value > 0 ? 'border: 1px solid #aaa;' : 'border: 1px solid #ddd; color: #aaa;'" style="background: #fff!important;" class="elevation-0 step-stepper--button step-stepper--button-increase"
                 @touchstart="onTouchStart"
                 @touchmove="onTouchMove"
                 @touchend="onTouchEnd(step)">+</div>
        </div>
        <slot name="addons"></slot>
    </div>
</template>

<style scoped lang="scss">
    .step-stepper + .step-stepper {
        border-top: 1px dotted #dfe0e2!important;
    }
    .step-stepper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 16px;
    }
    .step-stepper--header {
        flex-grow: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;

        .step-stepper--title {

        }

        .step-stepper--price {
            font-size: 14px;
        }
    }

    .step-stepper--buttons {
        white-space: nowrap;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .step-stepper--counter {
            min-width: 32px;
            text-align: center;
            display: inline-block;
            max-width: 62px;
            flex-grow: 1;
        }

        .step-stepper--button {
            display: inline-block;
            border-radius: 50%;
            padding: 0!important;
            margin: 0;
            text-align: center;
            width: 34px;
            height: 34px;
            line-height: 32px;
            min-width: 34px;
            background: rgba(0, 0, 0, 0.05)!important;
            font-size: 22px;

            & span {
                display: inline-block;
                line-height: 20px;
            }

            &.v-btn--disabled {
                color: rgba(0,0,0,0)!important;
            }
        }
    }

@media (min-width: 700px) {
    .overview--sub-title {
        font-size: 18px;
    }

    .step-stepper {
        height: 68px;
    }

    .step-stepper--title {
        font-size: 16px;
    }

    .step-stepper--price {
        font-size: 15px !important;
    }

    .step-stepper--counter {
        font-size: 20px;
    }

    .step-stepper--button:first-child {
        line-height: 36px !important;
    }

    .step-stepper--button {
        font-size: 32px !important;
        width: 44px !important;
        height: 44px !important;
        display: inline-block !important;
        justify-content: center !important;
        align-items: center !important;
        line-height: 40px !important;
    }
}
</style>

<script>
export default {
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        twoLine: {
            type: Boolean,
            default: false,
        },
        showPrice: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 16,
        },
        step: {
            type: Number,
            default: 1,
        },
        unitPrice: {
            type: Number,
            default: 0,
        },
    },
    created() {
        this.isMoving = false;
    },
    methods: {

        onTouchStart() {
            this.isMoving = false;
        },

        onTouchMove() {
            this.isMoving = true;
        },

        onTouchEnd(val) {
            if (this.isMoving) {
                this.isMoving = false;
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            this.modifyAmount(val);
        },


        modifyAmount(val) {
            const v = this.value + val;
            if (v < this.min || v > this.max) return;
            this.value = v;
            this.$emit("input", v);
            this.$set(this.$store.state.simplePlan, "emailSent", false);
            event.preventDefault();
            event.stopPropagation();
        },
    },
};
</script>
